export type CategoryType = "news" | "activity" | "life";

export interface CategoryItem {
  type: CategoryType;
  name: string;
  shortName: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: CategoryItem[] = [
  {
    type: "news",
    name: "演艺新闻",
    shortName: "新闻",
    description: "最新演艺动态、作品进展与行业相关报道，第一时间了解她的最新消息。",
    icon: "ri-newspaper-line",
    color: "primary",
  },
  {
    type: "activity",
    name: "活动动态",
    shortName: "活动",
    description: "见面会、品牌活动、公益行程等线下行程的完整记录与预告。",
    icon: "ri-calendar-event-line",
    color: "accent",
  },
  {
    type: "life",
    name: "生活动态",
    shortName: "生活",
    description: "日常花絮、写真更新与生活分享，感受镜头之外的真实一面。",
    icon: "ri-heart-line",
    color: "secondary",
  },
];

export const subCategoryMap: Record<string, string[]> = {
  news: ["演艺新闻", "作品资讯", "行业动态"],
  activity: ["见面会", "品牌活动", "公益行程"],
  life: ["日常花絮", "写真更新", "粉丝互动"],
};

export function getCategoryByType(type: string): CategoryItem | undefined {
  return categories.find((item) => item.type === type);
}